import { Object, Array, String, Static, Optional } from '@sinclair/typebox';

import { DapiError, DapiWarning } from '../dapi';

export const AcknowledgeRequestBody = Object({
  pnr: String(),
  lastName: String(),
  alternativeOfferBoundIds: Array(String()),
});
export type AcknowledgeRequestBody = Static<typeof AcknowledgeRequestBody>;

export const AcknowledgeResponse = Object({
  message: Optional(String()),
  detail: Optional(String()),
  warnings: Optional(Array(DapiWarning)),
  errors: Optional(Array(DapiError)),
});
export type AcknowledgeResponse = Static<typeof AcknowledgeResponse>;

export const AcknowledgeDapiResponse = Optional(
  Object({
    warnings: Optional(Array(DapiWarning)),
    errors: Optional(Array(DapiError)),
  })
);
export type AcknowledgeDapiResponse = Static<typeof AcknowledgeDapiResponse>;
